import { ClassicPreset } from "rete";
import { IapComponentDataSource } from "../../../../../component/domain/iapComponentDataSource";

export class DataSourceControl extends ClassicPreset.Control {
    constructor(public componentId:Number, public value:Number, public dataSources: IapComponentDataSource[], public onChange: (evt:any) => void) {
      super();
    }
  }